import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { adminRadii } from '../theme/adminTokens'

const listEmptyStateSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 150,
    px: 2,
    py: 4,
    my: 1,
    borderRadius: `${adminRadii.surface}px`,
    border: '1px dashed',
    borderColor: 'divider',
    backgroundColor: 'background.default',
    textAlign: 'center',
}

const variantStyleMap = {
    default: {
        titleColor: 'text.primary',
        descriptionColor: 'text.secondary',
        borderColor: 'divider',
        backgroundColor: 'background.default',
    },
    error: {
        titleColor: 'error.dark',
        descriptionColor: 'error.main',
        borderColor: 'error.border',
        backgroundColor: 'error.light',
    },
}

// 목록 테이블이 비었을 때 운영자가 다음 행동을 바로 판단할 수 있게 안내 문구와 액션을 통일한다.
export default function ListEmptyState({
    title,
    description,
    action,
    variant = 'default',
    sx,
}) {
    const variantStyle = variantStyleMap[variant] || variantStyleMap.default

    return (
        <Box
            sx={{
                ...listEmptyStateSx,
                borderColor: variantStyle.borderColor,
                backgroundColor: variantStyle.backgroundColor,
                ...sx,
            }}
        >
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: variantStyle.titleColor }}>
                {title}
            </Typography>
            {description && (
                <Typography variant="body2" sx={{ mt: 0.75, color: variantStyle.descriptionColor }}>
                    {description}
                </Typography>
            )}
            {action && (
                <Box sx={{ mt: 2 }}>
                    {action}
                </Box>
            )}
        </Box>
    )
}
